// src/components/ProtectedRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { isSessionValid, clearAuthData } from '../../utils/auth';

function ProtectedRoute({ children }) {
  if (!isSessionValid()) {
    clearAuthData();
    return <Navigate to="/login" replace />;
  }

  return children;
}

export default ProtectedRoute;
